type Props = {
    translatorName?: string;
    translatorThoughts?: JSX.Element;
};

export default function ChapterTranslatorThoughts({ translatorName, translatorThoughts }: Props) {
    return (
        <div className="prose max-w-none !pl-[15px] dark:prose-invert">
            <blockquote>
                <div className="text-[16px] font-semibold text-[#000000] dark:text-[#ffffff]">
                    {translatorName}'s Thoughts
                </div>
                <div
                    css={{
                        '&, *': {
                            background: 'none !important',
                        },
                    }}
                    className="mt-[12px]"
                >
                    {translatorThoughts}
                </div>
            </blockquote>
        </div>
    );
}
